// extracted by mini-css-extract-plugin
export var cartContainer = "_n9-4";
export var gray = "_n9-1";
export var itemContainer = "_n9-2";
export var itemDetails = "_n9-3";
export var strong = "_n9-0";